import React, { createContext, useState, useEffect } from 'react';

export interface TenantContextProps {
  tenantName: string;
  subdomain: string;
  logoUrl: string;
  loading: boolean;
}

export const TenantContext = createContext<TenantContextProps>({
  tenantName: 'Smart School Platform',
  subdomain: 'morenese',
  logoUrl: '',
  loading: true
});

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [tenantName, setTenantName] = useState('Morenese Mission School');
  const [subdomain, setSubdomain] = useState('morenese');
  const [logoUrl] = useState('https://images.unsplash.com/photo-1546410531-bb4caa6b424d?auto=format&fit=crop&q=80&w=200');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Resolve subdomain dynamically from browser URL path
    const host = window.location.host;
    const parts = host.split('.');
    
    if (parts.length >= 3 && parts[0] !== 'localhost' && !/^[0-9.]+$/.test(parts[0])) {
      const sub = parts[0];
      setSubdomain(sub);
      
      // Auto-capitalize school name based on parsed host subdomain
      const capitalized = sub.charAt(0).toUpperCase() + sub.slice(1);
      setTenantName(`${capitalized} Mission School`);
    } else {
      // Local dev default
      setSubdomain('morenese');
      setTenantName('Morenese Mission School');
    }
    
    setLoading(false);
  }, []);

  return (
    <TenantContext.Provider value={{ tenantName, subdomain, logoUrl, loading }}>
      {children}
    </TenantContext.Provider>
  );
};
